import ActionTypes from './ActionTypes';

const getGallery = payload => {
    return{
        type: ActionTypes.GET_GALLERY,
        payload,
    }
}

const updateGallery = payload => {
    return{
        type: ActionTypes.UPDATE_GALLERY,
        payload,
    }
}


const getSpecificCategory = payload => {
    return{
        type: ActionTypes.GET_SPECIFIC_CATEGORY,
        payload,
    }
}

const clearSpecificCategory = () => {
    return{
        type: ActionTypes.CLEAR_SPECIFIC_CATEGORY,
    }
}

const deleteGallery = payload => {
    return{
        type: ActionTypes.DELETE_GALLERY,
        payload,
    }
}

const getVendorPhotos = payload => {
    return{
        type: ActionTypes.GET_VENDOR_PHOTOS,
        payload,
    }
}


export { getGallery , getSpecificCategory, deleteGallery , clearSpecificCategory, getVendorPhotos,updateGallery };